import { useEffect, useState } from 'react'
import emailsApi from 'services/api/email'
import { unescapeRegex } from 'utils/common'

import ConfirmationDialog from '../../../components/ReusableComponents/ConfirmationDialog'

const EmailViewerDialog = ({ handleClose, emailId }) => {
  const [isLoading, setIsLoading] = useState(true)

  const [subject, setSubject] = useState()
  const [html, setHtml] = useState()

  useEffect(() => {
    setIsLoading(true)
    if (emailId) {
      emailsApi.getEmail({ id: emailId }).then(data => {
        setSubject(unescapeRegex(data.subject))
        setHtml(unescapeRegex(data.bodyInHtml))
        setIsLoading(false)
      })
    }
  }, [emailId])

  if (isLoading) return null

  return (
    <ConfirmationDialog
      title={subject}
      maxWidth={600}
      theme="blacklist"
      positiveMessage="Close"
      onClose={handleClose}
    >
      {html && <div dangerouslySetInnerHTML={{ __html: html }}></div>}
    </ConfirmationDialog>
  )
}

export default EmailViewerDialog
